/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig } from './lais/httpHelpers';

// Mensagens dos clientes — perguntas/comentários privados deixados pelos
// clientes nos imóveis (posts) do corretor logado. O backend já filtra apenas
// os imóveis do usuário (via agent_code dos perfis dele) e retorna as mais
// recentes primeiro.
class ListingInquiriesAPI extends ApiClient {
  constructor() {
    super('listing_inquiries', { accountScoped: true });
  }

  list() {
    return axios.get(this.url, requestConfig());
  }

  reply(id, text) {
    return axios.post(
      resourcePath(this.url, id, 'reply'),
      { text },
      requestConfig()
    );
  }
}

export default new ListingInquiriesAPI();
